export enum DeviceType {
  desktop = 'desktop',
  mobile = 'mobile',
}

export type Browser = string;
